import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAuthCustomer } from '../../core/models/auth.model';
import { URLS } from './url.constants';

@Injectable({
  providedIn: 'root',
})
export class AuthAPI {
  constructor(private _http: HttpClient) {}

  public requestLoginCode(phoneNumber: string, recaptcha_token: string): Observable<IAuthCustomer> {
    const data = { phone_number: phoneNumber, recaptcha_token: recaptcha_token };
    return this._http.post<IAuthCustomer>(`${URLS.LOGIN_CODE}`, data);
  }
}
